export const version = "providers/5.6.8";
//# sourceMappingURL=_version.js.map